import { FC, useEffect, useState } from 'react';
import ShuttleLayout from '../../components/layout/ShuttleLayout';
import { DatePicker } from "antd";
import styled from 'styled-components';
import moment from 'moment';
import { IGetBusSchedules } from '../../models/shuttleHelper.model';
import useAxios from '../../hooks/useAxios';
import { getBusSchedules } from '../../api/shuttleHelper.api';
import Button from '../../components/Button';
import { useHistory, useLocation } from 'react-router-dom';
import Loader from '../../components/Loader';
import ErrorResponse from '../../components/ErrorResponse';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/rootReducer';
import QueryString from 'qs';
import { useTranslation } from 'react-i18next';

const Block = styled.div`
  table th,
  table td {
    text-align: center;
    padding: 4px 2px;
  }

  .button {
    font-size: 24px;
    line-height: 24px;
    position: relative;
    top: 2px;
  }

  .button-image {
    width: 8px;
    height: 10px;
    margin: 10px;
  }
`;

const Shuttle: FC = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const query = QueryString.parse(location.search, { ignoreQueryPrefix: true });
  const queryDate = String(query.date);
  const { currentCampus } = useSelector((state: RootState) => state.auth);
  const { data: res, isLoading, error, execute } = useAxios<IGetBusSchedules>();
  const [date, setDate] = useState(moment().format('YYYYMMDD'));

  useEffect(() => {
    if (currentCampus) {
      if (queryDate === 'undefined') {
        doGetBusSchedules(date);
      } else {
        doGetBusSchedules(queryDate);
        setDate(queryDate);
      }
    }
  }, [currentCampus, location]);

  const doGetBusSchedules = (date: string) => execute(getBusSchedules(currentCampus, date));

  return (
    <ShuttleLayout>
      {isLoading ? <Loader /> : null}
      <ErrorResponse error={error} />

      <Block className="w-100">
        <div className="flex flex-justify-center">
          <div
            onClick={() => {
              if (date) {
                const yesterday = moment(date).subtract(1, 'days').format('YYYYMMDD');
                history.push(`?date=${yesterday}`);  
              }
            }}
          >
            <img
              className="button-image"
              src="/images/button-left.png"
              alt="left button"
            />
          </div>
          <div className="w-120p date-picker__area">
            <DatePicker
              value={date ? moment(date) : undefined}
              onChange={e => {
                if (!e) setDate('');
                else history.push(`?date=${moment(e).format('YYYYMMDD')}`);
              }}
            />
          </div>
          <div
            onClick={() => {
              if (date) {
                const tomorrow = moment(date).add(1, 'days').format('YYYYMMDD');
                history.push(`?date=${tomorrow}`);  
              }
            }}
          >
            <img
              className="button-image"
              src="/images/button-right.png"
              alt="left button"
            />
          </div>
        </div>
        <div className="mt-4">
          <table className="table-shuttle">
            <tbody>
              <tr>
                <th>{t('shuttle.text.33')}</th>
                <th>{t('shuttle.text.34')}</th>
                <th>{t('shuttle.text.43')}</th>
                <th>{t('shuttle.text.44')}</th>
                <th>{t('shuttle.text.45')}</th>
                <th>{t('shuttle.text.46')}</th>
              </tr>
              {
                res && res.data.length > 0
                  ? res.data.map((item, index) => (
                    <tr key={index}>
                      <td>{item.lineName}</td>
                      <td>{item.lineTime}</td>
                      <td>{item.busNo}<br />({item.driverName})</td>
                      <td>{item.rideGbn === 'UP' ? t('shuttle.text.8') : t('shuttle.text.9')}</td>
                      <td>{item.passengers}</td>
                      <td>
                        <Button
                          onClick={() => history.push(`/detail?runningCode=${item.runningCode}&rideGbn=${item.rideGbn}&date=${date}`)}
                          className="btn btn-sm btn-info btn-w40p"
                          text={t('student.student.64')}
                        />
                      </td>
                    </tr>
                  ))
                  : (
                    <tr>
                      <td colSpan={6}>{t('shuttle.text.40')}</td>
                    </tr>
                  )
              }
            </tbody>
          </table>
        </div>
      </Block>
    </ShuttleLayout>
  );
}

export default Shuttle;
